import baseUrl from '../utils/baseUrl'
import axios from './api'

const analyticsBase = `${baseUrl}/analytics`

const cleanParams = (filters = {}) => {
    const params = {}
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            params[key] = value
        }
    })
    return params
}

const get = async (path, filters = {}) =>
    axios.get(`${analyticsBase}${path}`, { params: cleanParams(filters) }).then((response) => response.data)

const getDashboard = (filters) => get('/dashboard', filters)
const getTimeline = (filters) => get('/timeline', filters)
const getWorkshops = (filters) => get('/workshops', filters)
const getWorkshopDetail = (id, filters) => get(`/workshops/${id}`, filters)
const getFunnel = (filters) => get('/funnel', filters)
const getUsers = (filters) => get('/users', filters)
const getReminders = (filters) => get('/reminders', filters)
const getMaintenance = (filters) => get('/maintenance', filters)
const getLoyalty = (filters) => get('/loyalty', filters)
const getCampaigns = (filters) => get('/campaigns', filters)
const getEvents = (filters) => get('/events', filters)
const getSystem = (filters) => get('/system', filters)

export {
    getDashboard,
    getTimeline,
    getWorkshops,
    getWorkshopDetail,
    getFunnel,
    getUsers,
    getReminders,
    getMaintenance,
    getLoyalty,
    getCampaigns,
    getEvents,
    getSystem
}
